module.exports = {
  src: __webpack_public_path__ + "assets/images/mobile_apple_store.b3562285d185adc8.png",
  width: 420,
  height: 144,
  toString: function() { return __webpack_public_path__ + "assets/images/mobile_apple_store.b3562285d185adc8.png"; }
};